import { render, staticRenderFns } from "./BundleItem.vue?vue&type=template&id=1f310ae0&scoped=true&"
import script from "./BundleItem.vue?vue&type=script&lang=js&"
export * from "./BundleItem.vue?vue&type=script&lang=js&"
import style0 from "./BundleItem.vue?vue&type=style&index=0&id=1f310ae0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f310ae0",
  null
  
)

export default component.exports